import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { signOutOptions } from '@/entities/admin-user';
import { ApiError } from '@/shared/api/http-client';

import { cognitoLogoutRedirect } from './cognito-logout-redirect';

export function useSignOut() {
    const queryClient = useQueryClient();

    // Callbacks live here, not on mutate(): SignOutMenuItem unmounts the instant the dropdown
    // item is clicked, and only useMutation's own options are guaranteed to still run then.
    const signOutMutation = useMutation({
        ...signOutOptions(),
        onSuccess: () => {
            // So the next staff member on this machine can't read the previous one's cached /auth/me.
            queryClient.clear();
            cognitoLogoutRedirect.perform();
        },
        onError: (error) => {
            if (error instanceof ApiError && error.status === 401) {
                // Session was already gone server-side — nothing left to clear, but the user
                // still needs to land on /sign-in rather than stay stuck on the dashboard.
                queryClient.clear();
                cognitoLogoutRedirect.perform();
                return;
            }
            // The session is still valid: redirecting would only bounce the user straight back
            // once the route guard's /auth/me succeeds, so surface the failure instead.
            toast.error('Sign out failed. Please try again.');
        },
    });

    return { signOut: () => signOutMutation.mutate(), isPending: signOutMutation.isPending };
}
